import React, { ReactElement } from 'react';

const ThinPlus = (): ReactElement => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M16.802 6.188L12 10.99 7.202 6.193c-.286-.263-.722-.255-.993.016l-.052.058c-.225.28-.208.692.052.952L10.99 12l-4.796 4.798c-.263.286-.255.722.016.993.271.27.707.28.989.02L12 13.01l4.798 4.797c.286.263.722.255.993-.016l.052-.058c.225-.28.208-.692-.052-.952l-4.781-4.782 4.797-4.797c.263-.286.255-.722-.016-.993-.271-.27-.707-.28-.989-.02z"
      transform="translate(-267 -720) translate(0 696) translate(235 16) translate(32 8) rotate(45 12 12)"
    />
  </svg>
);

export default ThinPlus;
